import styled from "styled-components"

export const Flex = styled.div`
  display: flex;
  align-items: center;
`

export const InstructionsButton = styled.div`
  margin: 20px 0 0;
`

export const InfoSections = styled.div`
  margin: 30px 0;
`

export const Accordions = styled.div`
  margin: 30px 0;
`

export const MarginLeft = styled.div`
  display: inline;
  margin-left: 5px;
`
